/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The unique ID of what the requirement is asking to be filled out.
 */
export const RequirementID = {
  AccountTosAcceptance: "account.tos-acceptance",
  IndividualMobile: "individual.mobile",
  IndividualEmail: "individual.email",
  IndividualEmailOrMobile: "individual.email-or-mobile",
  IndividualFirstname: "individual.firstname",
  IndividualLastname: "individual.lastname",
  IndividualAddress: "individual.address",
  IndividualSsnLast4: "individual.ssn-last4",
  IndividualSsn: "individual.ssn",
  IndividualBirthdate: "individual.birthdate",
  BusinessLegalname: "business.legalname",
  BusinessDescriptionOrWebsite: "business.description-or-website",
  BusinessEntityType: "business.entity-type",
  BusinessBusinessType: "business.business-type",
  BusinessDba: "business.dba",
  BusinessEin: "business.ein",
  BusinessAddress: "business.address",
  BusinessPhone: "business.phone",
  BusinessAdmins: "business.admins",
  BusinessControllers: "business.controllers",
  BusinessOwners: "business.owners",
  BusinessClassification: "business.classification",
  BusinessIndustryCodeMcc: "business.industry-code-mcc",
  BusinessIndustry: "business.industry",
  BusinessIndicateOwnersProvided: "business.indicate-owners-provided",
  BusinessAverageTransactionSize: "business.average-transaction-size",
  BusinessMaxTransactionSize: "business.max-transaction-size",
  BusinessAverageMonthlyTransactionVolume:
    "business.average-monthly-transaction-volume",
  BusinessVolumeByCustomerType: "business.volume-by-customer-type",
  BusinessCardVolumeDistribution: "business.card-volume-distribution",
  BusinessFulfillment: "business.fulfillment",
  BusinessDescription: "business.description",
  BusinessUnderwritingDocumentsTierOne:
    "business.underwriting-documents-tier-one",
  BankAccountsName: "bank-accounts.name",
  BankAccountsRoutingNumber: "bank-accounts.routing-number",
  BankAccountsAccountNumber: "bank-accounts.account-number",
  DocumentBusinessVerification: "document.business.verification",
  DocumentIndividualTin: "document.individual.tin",
  DocumentIndividualVerification: "document.individual.verification",
  DocumentRepresentativeRepUuidTin: "document.representative.{rep-uuid}.tin",
  DocumentRepresentativeRepUuidVerification:
    "document.representative.{rep-uuid}.verification",
  RepresentativeRepUuidMobile: "representative.{rep-uuid}.mobile",
  RepresentativeRepUuidEmail: "representative.{rep-uuid}.email",
  RepresentativeRepUuidEmailOrMobile:
    "representative.{rep-uuid}.email-or-mobile",
  RepresentativeRepUuidFirstname: "representative.{rep-uuid}.firstname",
  RepresentativeRepUuidLastname: "representative.{rep-uuid}.lastname",
  RepresentativeRepUuidAddress: "representative.{rep-uuid}.address",
  RepresentativeRepUuidSsnLast4: "representative.{rep-uuid}.ssn-last4",
  RepresentativeRepUuidSsn: "representative.{rep-uuid}.ssn",
  RepresentativeRepUuidBirthdate: "representative.{rep-uuid}.birthdate",
  RepresentativeRepUuidJobTitle: "representative.{rep-uuid}.job-title",
  RepresentativeRepUuidIsController: "representative.{rep-uuid}.is-controller",
  RepresentativeRepUuidIsOwner: "representative.{rep-uuid}.is-owner",
  RepresentativeRepUuidOwnership: "representative.{rep-uuid}.ownership",
  DocumentDocUuid: "document.{doc-uuid}",
  UnderwritingBusinessPresence: "underwriting.businessPresence",
  UnderwritingGeographicReach: "underwriting.geographicReach",
  UnderwritingVolumeShareByCustomerType:
    "underwriting.volumeShareByCustomerType",
  UnderwritingPendingLitigation: "underwriting.pendingLitigation",
  UnderwritingDocumentsProcessingStatementsPast3Months:
    "underwriting.documents.processingStatementsPast3Months",
  UnderwritingCollectFundsCardPaymentsCardAcceptanceMethods:
    "underwriting.collectFunds.cardPayments.cardAcceptanceMethods",
  UnderwritingCollectFundsCardPaymentsCurrentlyAcceptsCards:
    "underwriting.collectFunds.cardPayments.currentlyAcceptsCards",
  UnderwritingCollectFundsCardPaymentsEstimatedActivityAverageTransactionAmount:
    "underwriting.collectFunds.cardPayments.estimatedActivity.averageTransactionAmount",
  UnderwritingCollectFundsCardPaymentsEstimatedActivityMaximumTransactionAmount:
    "underwriting.collectFunds.cardPayments.estimatedActivity.maximumTransactionAmount",
  UnderwritingCollectFundsCardPaymentsEstimatedActivityMonthlyVolumeRange:
    "underwriting.collectFunds.cardPayments.estimatedActivity.monthlyVolumeRange",
  UnderwritingCollectFundsCardPaymentsFulfillment:
    "underwriting.collectFunds.cardPayments.fulfillment",
  UnderwritingCollectFundsCardPaymentsRefundPolicy:
    "underwriting.collectFunds.cardPayments.refundPolicy",
  UnderwritingCollectFundsAchCardAcceptanceMethods:
    "underwriting.collectFunds.ach.cardAcceptanceMethods",
  UnderwritingCollectFundsAchCurrentlyAcceptsCards:
    "underwriting.collectFunds.ach.currentlyAcceptsCards",
  UnderwritingCollectFundsAchEstimatedActivityAverageTransactionAmount:
    "underwriting.collectFunds.ach.estimatedActivity.averageTransactionAmount",
  UnderwritingCollectFundsAchEstimatedActivityMaximumTransactionAmount:
    "underwriting.collectFunds.ach.estimatedActivity.maximumTransactionAmount",
  UnderwritingCollectFundsAchEstimatedActivityMonthlyVolumeRange:
    "underwriting.collectFunds.ach.estimatedActivity.monthlyVolumeRange",
  UnderwritingCollectFundsAchFulfillment:
    "underwriting.collectFunds.ach.fulfillment",
  UnderwritingCollectFundsAchRefundPolicy:
    "underwriting.collectFunds.ach.refundPolicy",
  UnderwritingSendFundsAchCardAcceptanceMethods:
    "underwriting.sendFunds.ach.cardAcceptanceMethods",
  UnderwritingSendFundsAchCurrentlyAcceptsCards:
    "underwriting.sendFunds.ach.currentlyAcceptsCards",
  UnderwritingSendFundsAchEstimatedActivityAverageTransactionAmount:
    "underwriting.sendFunds.ach.estimatedActivity.averageTransactionAmount",
  UnderwritingSendFundsAchEstimatedActivityMaximumTransactionAmount:
    "underwriting.sendFunds.ach.estimatedActivity.maximumTransactionAmount",
  UnderwritingSendFundsAchEstimatedActivityMonthlyVolumeRange:
    "underwriting.sendFunds.ach.estimatedActivity.monthlyVolumeRange",
  UnderwritingSendFundsAchFulfillment: "underwriting.sendFunds.ach.fulfillment",
  UnderwritingSendFundsAchRefundPolicy:
    "underwriting.sendFunds.ach.refundPolicy",
  UnderwritingSendFundsRtpCardAcceptanceMethods:
    "underwriting.sendFunds.rtp.cardAcceptanceMethods",
  UnderwritingSendFundsRtpCurrentlyAcceptsCards:
    "underwriting.sendFunds.rtp.currentlyAcceptsCards",
  UnderwritingSendFundsRtpEstimatedActivityAverageTransactionAmount:
    "underwriting.sendFunds.rtp.estimatedActivity.averageTransactionAmount",
  UnderwritingSendFundsRtpEstimatedActivityMaximumTransactionAmount:
    "underwriting.sendFunds.rtp.estimatedActivity.maximumTransactionAmount",
  UnderwritingSendFundsRtpEstimatedActivityMonthlyVolumeRange:
    "underwriting.sendFunds.rtp.estimatedActivity.monthlyVolumeRange",
  UnderwritingSendFundsRtpFulfillment: "underwriting.sendFunds.rtp.fulfillment",
  UnderwritingSendFundsRtpRefundPolicy:
    "underwriting.sendFunds.rtp.refundPolicy",
  UnderwritingSendFundsPushToCardCardAcceptanceMethods:
    "underwriting.sendFunds.pushToCard.cardAcceptanceMethods",
  UnderwritingSendFundsPushToCardCurrentlyAcceptsCards:
    "underwriting.sendFunds.pushToCard.currentlyAcceptsCards",
  UnderwritingSendFundsPushToCardEstimatedActivityAverageTransactionAmount:
    "underwriting.sendFunds.pushToCard.estimatedActivity.averageTransactionAmount",
  UnderwritingSendFundsPushToCardEstimatedActivityMaximumTransactionAmount:
    "underwriting.sendFunds.pushToCard.estimatedActivity.maximumTransactionAmount",
  UnderwritingSendFundsPushToCardEstimatedActivityMonthlyVolumeRange:
    "underwriting.sendFunds.pushToCard.estimatedActivity.monthlyVolumeRange",
  UnderwritingSendFundsPushToCardFulfillment:
    "underwriting.sendFunds.pushToCard.fulfillment",
  UnderwritingSendFundsPushToCardRefundPolicy:
    "underwriting.sendFunds.pushToCard.refundPolicy",
  UnderwritingMoneyTransferPullFromCardCardAcceptanceMethods:
    "underwriting.moneyTransfer.pullFromCard.cardAcceptanceMethods",
  UnderwritingMoneyTransferPullFromCardCurrentlyAcceptsCards:
    "underwriting.moneyTransfer.pullFromCard.currentlyAcceptsCards",
  UnderwritingMoneyTransferPullFromCardEstimatedActivityAverageTransactionAmount:
    "underwriting.moneyTransfer.pullFromCard.estimatedActivity.averageTransactionAmount",
  UnderwritingMoneyTransferPullFromCardEstimatedActivityMaximumTransactionAmount:
    "underwriting.moneyTransfer.pullFromCard.estimatedActivity.maximumTransactionAmount",
  UnderwritingMoneyTransferPullFromCardEstimatedActivityMonthlyVolumeRange:
    "underwriting.moneyTransfer.pullFromCard.estimatedActivity.monthlyVolumeRange",
  UnderwritingMoneyTransferPullFromCardFulfillment:
    "underwriting.moneyTransfer.pullFromCard.fulfillment",
  UnderwritingMoneyTransferPullFromCardRefundPolicy:
    "underwriting.moneyTransfer.pullFromCard.refundPolicy",
  UnderwritingMoneyTransferPushToCardCardAcceptanceMethods:
    "underwriting.moneyTransfer.pushToCard.cardAcceptanceMethods",
  UnderwritingMoneyTransferPushToCardCurrentlyAcceptsCards:
    "underwriting.moneyTransfer.pushToCard.currentlyAcceptsCards",
  UnderwritingMoneyTransferPushToCardEstimatedActivityAverageTransactionAmount:
    "underwriting.moneyTransfer.pushToCard.estimatedActivity.averageTransactionAmount",
  UnderwritingMoneyTransferPushToCardEstimatedActivityMaximumTransactionAmount:
    "underwriting.moneyTransfer.pushToCard.estimatedActivity.maximumTransactionAmount",
  UnderwritingMoneyTransferPushToCardEstimatedActivityMonthlyVolumeRange:
    "underwriting.moneyTransfer.pushToCard.estimatedActivity.monthlyVolumeRange",
  UnderwritingMoneyTransferPushToCardFulfillment:
    "underwriting.moneyTransfer.pushToCard.fulfillment",
  UnderwritingMoneyTransferPushToCardRefundPolicy:
    "underwriting.moneyTransfer.pushToCard.refundPolicy",
} as const;
/**
 * The unique ID of what the requirement is asking to be filled out.
 */
export type RequirementID = ClosedEnum<typeof RequirementID>;

/** @internal */
export const RequirementID$inboundSchema: z.ZodNativeEnum<
  typeof RequirementID
> = z.nativeEnum(RequirementID);
/** @internal */
export const RequirementID$outboundSchema: z.ZodNativeEnum<
  typeof RequirementID
> = RequirementID$inboundSchema;
